import React from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import styles from './Breadcrumb.module.css';
import { useTranslation } from 'react-i18next';

export default function Breadcrumb() {
  const location = useLocation();
  const [params] = useSearchParams();
  const path = location.pathname;
  const featureId = params.get('feature');
  const { t } = useTranslation();

  return (
    <div className={styles.breadcrumb}>
      <Link to="/">{t('ui.home')}</Link>
      <span>/</span>
      <Link to="/about">{t('ui.about')}</Link>
      {path === '/about' && featureId && (
        <>
          <span>/</span>
          <span>{t('ui.newFeatures')}</span>
          <span>/</span>
          <span>{featureId}</span>
        </>
      )}
    </div>
  );
}
